import { Box } from '@gusto/workbench';
import useResponsive from 'packages/signup/helpers/useResponsive';

const HEADER_COPY = {
  nonOrganic: 'Get started with Gusto',
  organic: 'Create a Gusto account',
  paidPayroll041: 'Create a Gusto account',
};

const SUBHEADER_COPY = {
  nonOrganic: 'We offer one intuitive place to manage payroll, benefits, and HR for your business.',
  organic:
    'It’s free to set up your company with Gusto. You won’t pay a cent until you’re ready to run payroll.',
  organicMobile: 'You won’t pay a cent until you’re ready to run payroll.',
  paidPayroll041: 'You won’t pay a cent until you run your first payroll.',
};

export const SinglePageSubHeader = ({ copy, className }: { copy: string; className?: string }) => {
  return (
    <Box component="p" className={`layout-subheading ${className}`} marginBottom={3}>
      {copy}
    </Box>
  );
};

export const SinglePageSubHeaderWrapper = ({
  contentType,
  className,
}: {
  contentType: string;
  className?: string;
}) => {
  const { isMobile } = useResponsive();
  if (contentType === 'non-organic')
    return <SinglePageSubHeader copy={SUBHEADER_COPY.nonOrganic} className={className} />;

  return (
    <SinglePageSubHeader
      copy={isMobile ? SUBHEADER_COPY.organicMobile : SUBHEADER_COPY.organic}
      className={className}
    />
  );
};

export const SinglePageHeader = ({
  copy,
  headingSize = 2,
}: {
  copy: string;
  headingSize?: 1 | 2 | 3 | 4 | 5 | 6;
}) => {
  return (
    <Box component={`h${headingSize}`} marginBottom={3}>
      {copy}
    </Box>
  );
};

export const SinglePageHeaderWrapper = ({ contentType }: { contentType: string }) => {
  if (contentType === 'non-organic') return <SinglePageHeader copy={HEADER_COPY.nonOrganic} />;

  return <SinglePageHeader copy={HEADER_COPY.organic} />;
};

export const SinglePaidPayroll041PageWrapper = () => {
  return (
    <>
      <SinglePageHeader copy={HEADER_COPY.paidPayroll041} />
      <SinglePageSubHeader copy={SUBHEADER_COPY.paidPayroll041} />
    </>
  );
};
